module.exports = {
      id: "ic-overwrite-state-usage",
      viewBox: "0 0 128 128",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#ic-overwrite-state-usage",
      toString: function () {
        return this.url;
      }
    }